<div class="view-container">
  <mat-card *ngIf="recipeEventSummary">
    <mat-card-content class="w-100" fxFlex="100" fxLayout="row wrap" fxLayoutAlign="start center">
      <div class="card-title" fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="start start">
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px">
          <strong fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">
            {{ productName[recipeEventSummary?.productName] }}
            <mat-icon *ngIf="getStatusIconAndClass(recipeEventSummary)?.class" [class]="getStatusIconAndClass(recipeEventSummary).class" class="m-l-10 m-r-10"
              [matTooltip]="getStatusIconAndClass(recipeEventSummary).description">
              {{ getStatusIconAndClass(recipeEventSummary).icon }}
            </mat-icon>
            <span *ngIf="situLinkUrl as url" class="situ-link-pill">
              <a target="_blank" [href]="url" [matTooltip]="url"><mat-icon>link</mat-icon>situLINK</a>
              <copy-value label="situLINK" [value]="url" [alwaysVisible]="true"></copy-value>
            </span>
          </strong>

          <!-- Manual refresh, when automatic refreshing is off or running late -->
          <button *ngIf="showManualRefresh" mat-icon-button
            [class.text-warning]="pollingStoppedAfterFailures || isAutoRefreshLate"
            [matTooltip]="manualRefreshTooltip" (click)="manualRefresh()">
            <mat-icon>refresh</mat-icon>
          </button>

          <!-- Action Buttons Group -->
          <div *ngIf="canUpdateStatus()" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px" class="action-buttons">
            <small class="text-muted m-r-10" style="opacity: 0.7;">Actions:</small>
            <button mat-icon-button 
              [disabled]="updating"
              (click)="updateStatus(true, false)"
              matTooltip="Mark as failed"
              class="text-danger">
              <mat-icon>error</mat-icon>
            </button>
            <button mat-icon-button 
              [disabled]="updating"
              (click)="updateStatus(false, true)"
              matTooltip="Mark as cancelled"
              class="text-muted">
              <mat-icon>cancel</mat-icon>
            </button>
          </div>
        </div>
        <small class="copyable">
          Artifact ID: <a class="link" matTooltip="View in SEQ" target="_blank" [href]="getSeqUrl(recipeEventSummary?.artifactId, false)"><span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">{{ recipeEventSummary?.artifactId }}</span></a>
          <copy-value label="Artifact ID" [value]="recipeEventSummary?.artifactId"></copy-value>
        </small>
      </div>
      <div class="w-100 m-t-20" fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutAlign="center start" fxLayoutAlign.lt-sm="start start">
        <div fxFlex="40" fxLayout="column" fxLayoutAlign="start start">
          <small class="copyable">
            Company: <a class="link" matTooltip="View Company {{ recipeEventSummary?.companyId }}" [routerLink]="['/admin/companies', recipeEventSummary?.companyId]"><span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">{{ recipeEventSummary?.companyCode }}</span></a>
            <copy-value label="Company" [value]="recipeEventSummary?.companyCode"></copy-value>
          </small>
          <small class="copyable" *ngIf="recipeEventSummary?.sourceName">
            Source: <span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">{{ recipeEventSummary?.sourceName }}</span>
            <copy-value label="Source" [value]="recipeEventSummary?.sourceName"></copy-value>
          </small>
          <small class="copyable" *ngIf="recipeEventSummary?.home">
            Home: <a class="link" matTooltip="View Home" [routerLink]="['/homes', recipeEventSummary.home]"><span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">{{ recipeEventSummary.home }}</span></a>
            <copy-value label="Home" [value]="recipeEventSummary.home"></copy-value>
          </small>
          <small class="copyable" *ngIf="recipeEventSummary?.home && recipeEventSummary?.masterFile">
            MasterFile: <a class="link" matTooltip="View Ifc File" [routerLink]="['/homes', recipeEventSummary.home]" [queryParams]="{ ifcFile: recipeEventSummary.masterFile }"><span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">{{ recipeEventSummary.masterFile }}</span></a>
            <copy-value label="MasterFile" [value]="recipeEventSummary.masterFile"></copy-value>
          </small>
          <small class="copyable" *ngIf="recipeEventSummary?.home && recipeEventSummary?.options">
            Options: <span *ngFor="let option of recipeEventSummary.options.split(',')">
              <a class="link" matTooltip="View Ifc File" [routerLink]="['/homes', recipeEventSummary.home]" [queryParams]="{ ifcFile: option }"><span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">{{ option }}</span></a>
            </span>
            <copy-value label="Options" [value]="recipeEventSummary.options"></copy-value>
          </small>
          <small class="copyable" *ngIf="recipeEventSummary?.home && recipeEventSummary?.themes">
            Themes: <span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }" [matTooltip]="recipeEventSummary.themes">{{ recipeEventSummary.themes | arrayCount:'~' }}</span>
            <copy-value label="Themes" [value]="recipeEventSummary.themes"></copy-value>
          </small>
        </div>
        <div fxFlex="60" fxLayout="column" fxLayoutAlign="start start">
          <small class="copyable">
            Date Added: <span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }" [matTooltip]="timeAgoString(recipeEventSummary?.dateAdded)">{{ recipeEventSummary?.dateAdded | date:'medium' }}</span>
            <copy-value label="Date Added" [value]="recipeEventSummary?.dateAdded?.toISOString()"></copy-value>
          </small>
          <small class="copyable">
            Renderer: <a class="link"  target="_blank" matTooltip="View Renderer {{ recipeEventSummary?.rendererName }}" [routerLink]="['/admin/renderers', recipeEventSummary?.rendererId, 'dashboard']"><span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">{{ recipeEventSummary?.rendererName }}</span></a>
            <copy-value label="Renderer" [value]="recipeEventSummary?.rendererName"></copy-value>
          </small>
          <small class="copyable">
            Queue: <span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">{{ recipeEventSummary?.queueName }}</span>
            <copy-value label="Queue" [value]="recipeEventSummary?.queueName"></copy-value>
          </small>
          <small class="copyable">
            RenderedOutput ID: <a *ngIf="getRenderedOutputRoute(recipeEventSummary?.productName) as renderedOutputRoute; else renderedOutputIdText" class="link" target="_blank"
              [routerLink]="renderedOutputIdInPath(recipeEventSummary?.productName) ? [renderedOutputRoute, recipeEventSummary?.renderedOutputId] : [renderedOutputRoute]"
              [queryParams]="renderedOutputIdInPath(recipeEventSummary?.productName) ? undefined : { id: recipeEventSummary?.renderedOutputId }"><ng-container *ngTemplateOutlet="renderedOutputIdText"></ng-container></a>
            <ng-template #renderedOutputIdText><span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">{{ recipeEventSummary?.renderedOutputId }}</span></ng-template>
            <copy-value label="RenderedOutput ID" [value]="recipeEventSummary?.renderedOutputId"></copy-value>
          </small>
          <small class="copyable">
            Correlation ID: <a class="link" matTooltip="View in SEQ" target="_blank" [href]="getSeqUrl(recipeEventSummary?.correlationId, true)"><span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">{{ recipeEventSummary?.correlationId }}</span></a>
            <copy-value label="Correlation ID" [value]="recipeEventSummary?.correlationId"></copy-value>
          </small>
          <small fxLayout="row" fxLayoutAlign="start center" *ngIf="recipeEventSummary?.baseIngredients?.length > 0">
            Base Ingredients: <span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }"><source-artifacts-menu class="card-icon" [isSituUser]="isSituUser" [isAdmin]="isAdmin" [isDarkMode]="isDarkMode" [sourceArtifacts]="recipeEventSummary.baseIngredients"></source-artifacts-menu></span>
          </small>
        </div>
        
        <!-- Key Information Above Sub-Cards -->
        <div fxFlex="100" class="m-t-20" fxLayout="column" fxLayoutAlign="start center">
          <small class="w-100 copyable">
            Key: <a class="link key" matTooltip="Search Key" [routerLink]="['/admin/artifacts']" [queryParams]="{ id: recipeEventSummary.artifactId }"><span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">{{ recipeEventSummary?.artifactKey }}</span></a>
            <copy-value label="Key" [value]="recipeEventSummary?.artifactKey"></copy-value>
          </small>
        </div>
        
        <!-- Information Sub-Cards Row - Side by Side on Right -->
        <div fxFlex="100" class="m-t-10" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutAlign="end start" fxLayoutAlign.lt-md="start stretch">
          
          <!-- Artifact Information Sub-Card -->
          <div *ngIf="artifactInfo" fxFlex="50" fxFlex.lt-md="100">
            <mat-card class="mat-card-inline-sm w-100">
              <mat-card-content>
                <div class="card-title m-b-10" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
                  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                    <mat-icon [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">inventory_2</mat-icon>
                    <strong [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">Artifact Information</strong>
                  </div>
                  <button mat-icon-button 
                    [color]="artifactInfo?.active ? 'warn' : 'primary'"
                    [matTooltip]="artifactInfo?.active ? 'Disable Artifact' : 'Enable Artifact'"
                    (click)="toggleArtifactActive()">
                    <mat-icon>{{ artifactInfo?.active ? 'toggle_off' : 'toggle_on' }}</mat-icon>
                  </button>
                </div>
                <div fxLayout="column" fxLayoutAlign="start start">
                  <small class="copyable" *ngIf="artifactInfo?.callerReferenceKey">
                    <strong>Name: </strong><span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }" style="word-break: break-all;">{{ artifactInfo.callerReferenceKey }}</span>
                    <copy-value label="Name" [value]="artifactInfo.callerReferenceKey"></copy-value>
                  </small>
                  <small class="copyable" *ngIf="artifactInfo?.version">
                    <strong>Version: </strong><span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">{{ artifactInfo.version }}</span>
                    <copy-value label="Version" [value]="artifactInfo.version"></copy-value>
                  </small>
                  <small class="copyable" *ngIf="getArtifactType(artifactInfo)">
                    <strong>Type: </strong><span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">{{ getArtifactType(artifactInfo) }}</span>
                    <copy-value label="Type" [value]="getArtifactType(artifactInfo)"></copy-value>
                  </small>
                  <small class="copyable" *ngIf="getArtifactInstanceName(artifactInfo)">
                    <strong>Instance Name: </strong><span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">{{ getArtifactInstanceName(artifactInfo) }}</span>
                    <copy-value label="Instance Name" [value]="getArtifactInstanceName(artifactInfo)"></copy-value>
                  </small>
                  <small class="copyable" *ngIf="artifactInfo?.dateAdded">
                    <strong>Created: </strong><span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }" [matTooltip]="timeAgoString(artifactInfo.dateAdded)">{{ artifactInfo.dateAdded | date:'medium' }}</span>
                    <copy-value label="Created" [value]="artifactInfo.dateAdded?.toISOString()"></copy-value>
                  </small>
                  <small class="copyable" *ngIf="artifactInfo?.active !== undefined">
                    <strong>Status: </strong><span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">{{ artifactInfo.active ? 'Active' : 'Inactive' }}</span>
                    <copy-value label="Status" [value]="artifactInfo.active ? 'Active' : 'Inactive'"></copy-value>
                  </small>
                  <small *ngIf="artifactInfo?.metaData?.length > 0" fxLayout="row" fxLayoutAlign="start center">
                    <strong>Metadata: </strong>
                    <artifact-metadata-menu class="card-icon m-l-5"
                      [isDarkMode]="isDarkMode"
                      [metaData]="artifactInfo.metaData">
                    </artifact-metadata-menu>
                  </small>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

          <!-- Rendered Output Information Sub-Card -->
          <div *ngIf="renderedOutputInfo && recipeEventSummary?.renderedOutputId" fxFlex="50" fxFlex.lt-md="100">
            <mat-card class="mat-card-inline-sm w-100">
              <mat-card-content>
                <div class="card-title m-b-10" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
                  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                    <mat-icon [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">visibility</mat-icon>
                    <strong [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">Rendered Output</strong>
                  </div>
                  <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
                    <button mat-icon-button 
                      color="basic"
                      matTooltip="Cancel Rendered Output"
                      (click)="setRenderedOutputStatus(status.Cancelled)">
                      <mat-icon>cancel</mat-icon>
                    </button>
                    <button mat-icon-button 
                      color="warn"
                      matTooltip="Mark Rendered Output as Failed"
                      (click)="setRenderedOutputStatus(status.Failed)">
                      <mat-icon>error</mat-icon>
                    </button>
                  </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="start start">
                  <small class="copyable" *ngIf="renderedOutputInfo?.name">
                    <strong>Name: </strong><span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">{{ renderedOutputInfo.name }}</span>
                    <copy-value label="Name" [value]="renderedOutputInfo.name"></copy-value>
                  </small>
                  <small class="copyable" *ngIf="getStyleTemplateName(renderedOutputInfo)">
                    <strong>Style Template: </strong><a class="link" matTooltip="View Style Template" target="_blank" [routerLink]="['/admin/style-template', getStyleTemplateId(renderedOutputInfo)]"><span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">{{ getStyleTemplateName(renderedOutputInfo) }}</span></a>
                    <copy-value label="Style Template" [value]="getStyleTemplateName(renderedOutputInfo)"></copy-value>
                  </small>
                  <small class="copyable" *ngIf="renderedOutputInfo?.status">
                    <strong>Status: </strong>
                    <span [ngStyle]="{ 'color': getRenderedOutputStatusColor(renderedOutputInfo.status) }">
                      {{ status[renderedOutputInfo.status] }}
                    </span>
                    <copy-value label="Status" [value]="status[renderedOutputInfo.status]"></copy-value>
                  </small>
                  <small class="copyable" *ngIf="renderedOutputInfo?.dateSubmitted">
                    <strong>Submitted: </strong><span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }" [matTooltip]="timeAgoString(renderedOutputInfo.dateSubmitted)">{{ renderedOutputInfo.dateSubmitted | date:'medium' }}</span>
                    <copy-value label="Submitted" [value]="renderedOutputInfo.dateSubmitted?.toISOString()"></copy-value>
                  </small>
                  <small class="copyable" *ngIf="renderedOutputInfo?.dateCompleted">
                    <strong>Completed: </strong><span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }" [matTooltip]="timeAgoString(renderedOutputInfo.dateCompleted)">{{ renderedOutputInfo.dateCompleted | date:'medium' }}</span>
                    <copy-value label="Completed" [value]="renderedOutputInfo.dateCompleted?.toISOString()"></copy-value>
                  </small>
                  <small class="copyable" *ngIf="renderedOutputInfo?.renderTimeInSeconds">
                    <strong>Render Time: </strong><span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">{{ renderedOutputInfo.renderTimeInSeconds }}s</span>
                    <copy-value label="Render Time" [value]="renderedOutputInfo.renderTimeInSeconds + 's'"></copy-value>
                  </small>
                  <small class="copyable" *ngIf="renderedOutputInfo?.artifactId">
                    <strong>Artifact ID: </strong><span [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">{{ renderedOutputInfo.artifactId }}</span>
                    <copy-value label="Artifact ID" [value]="renderedOutputInfo.artifactId"></copy-value>
                  </small>
                  <small *ngIf="renderedOutputInfo?.sourceArtifacts && renderedOutputInfo.sourceArtifacts.length > 0" fxLayout="row" fxLayoutAlign="start center">
                    <strong>Source Artifacts: </strong>
                    <source-artifacts-menu class="card-icon m-l-5" 
                      [isSituUser]="isSituUser" 
                      [isAdmin]="isAdmin" 
                      [isDarkMode]="isDarkMode" 
                      [sourceArtifacts]="renderedOutputInfo.sourceArtifacts">
                    </source-artifacts-menu>
                  </small>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

        </div>
        
        <div fxFlex="100" class="m-t-20">
          <recipe-progress-bar [recipeEventSummary]="recipeEventSummary" (eventSelected)="scrollToEvent($event)"></recipe-progress-bar>
        </div>
      </div>
      <div class="card-title m-t-20" fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
        <strong style="opacity: 0.7;" [ngStyle]="{ 'color': getProductColour(recipeEventSummary?.productName) }">
          Timeline
        </strong>
      </div>
      <ng-container *ngFor="let item of timelineEvents; let i = index">
        <mat-card class="mat-card-inline-sm contrast w-100 banner-{{item?.eventTypeStyle}}">
          <mat-card-content class="contain-content">
            <span class="text-{{item?.eventTypeStyle}}">{{ item?.eventMessage }}</span> @ <small class="text-{{item?.eventTypeStyle}}">{{ item?.eventDateTime | date:'long' }}</small>
          </mat-card-content>
        </mat-card>
        <i *ngIf="getTimeToNextEvent(timelineEvents, i)" fxLayout="row" fxLayoutAlign="start center"><mat-icon color="accent">add</mat-icon>{{ getTimeToNextEvent(timelineEvents, i) }}</i>
      </ng-container>
      <i *ngIf="recipeEventSummary?.totalTimeInSeconds" fxLayout="row" fxLayoutAlign="start center"><mat-icon color="accent">done</mat-icon>{{ recipeEventSummary?.totalTimeInSeconds }}s</i>
      <mat-card class="m-t-20 w-100">
        <mat-card-content>
          <div class="card-title link" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" (click)="toggleTimeline()">
            <span>{{ showTimeline ? 'Hide' : 'Show' }} complete timeline </span>
            <mat-icon [color]="showTimeline ? 'accent' : 'basic'">timeline</mat-icon>
          </div>
          <ng-container *ngIf="showTimeline && recipeEventSummaryGrouped?.groups">
            <ng-container *ngFor="let eventGroup of recipeEventSummaryGrouped.groups; let i = index">
            
              <!-- Optional: show the "time since last group" above the card -->
              <i *ngIf="eventGroup.timeSinceLastGroup" fxLayout="row" fxLayoutAlign="start center">
                <mat-icon color="accent">add</mat-icon> {{ eventGroup.timeSinceLastGroup }}
              </i>
            
              <!-- Whole group wrapped in one mat-card -->
              <mat-card *ngIf="eventGroup.events.length > 0" class="mat-card-inline-sm contrast w-100 event-timeline-group">
            
                <mat-card-content class="contain-content">
            
                  <!-- Loop over each event in the group -->
                  <div *ngFor="let item of eventGroup.events"
                    class="event-timeline-group-row" [id]="'recipe-event-' + item.id" [class.highlighted]="item.id === highlightedEventId"
                    (click)="isLink(item) ? viewArtifactFile(item) : null" style="cursor: pointer; margin-bottom: 6px;">
                    <code>{{ item?.dateTimeStamp | date:'YYYY-MM-dd HH:mm:ss' }}</code>
                    <small class="m-r-5 text-success">{{ getEventType(item) }}</small>
                    <span>{{ getEventMessage(item) }}</span>
                    <mat-icon class="p-l-5" *ngIf="isLink(item)" color="accent">open_in_new</mat-icon>
                  </div>
            
                </mat-card-content>
              </mat-card>
            </ng-container>
          </ng-container>
        </mat-card-content>
      </mat-card>
    </mat-card-content>
  </mat-card>
  <mat-card *ngIf="!recipeEventSummary">
    <mat-card-content>
      This recipe event summary does not exist
    </mat-card-content>
  </mat-card>
</div>
<!-- 
<pre>
  {{ recipeEventSummary | json }}
</pre> -->